import * as React from "react"
import { CreatePoll } from "./create-poll"
import { Box, List } from "@chakra-ui/react"
import styled from "@emotion/styled"
import { useRecoilValue, useSetRecoilState } from "recoil"
import {
  pollsAtom,
  pollsTamplateAtom,
  pollsTamplateSelector
} from "../../../recoil/atoms/polls"
import { CreateAnotherPoll, CreateAnotherPollContainer } from "./polls.styled"
import { createTamplatePoll } from "../../../util/"
import { brandingSelector } from "../../../recoil/atoms/room"
import type { Room } from "../../../recoil/atoms/room/types"
import { useTranslation } from "react-i18next"

interface StyledProps {
  room?: Room
}

const Container = styled(List)<StyledProps>`
  &::-webkit-scrollbar-track {
    background: ${({ roomStyles }) =>
      roomStyles.servicePanelElementBorder || "#cbd5e0"};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ roomStyles }) =>
      roomStyles.servicePanelElementBorderOffset || "#fff"};
    border-radius: 10px;
  }
`

const _Polls = () => {
  const polls = useRecoilValue(pollsAtom)
  const roomStyles = useRecoilValue(brandingSelector)
  const tamplatePolls = useRecoilValue(pollsTamplateAtom)

  const setTamplatePolls = useSetRecoilState(pollsTamplateSelector)

  const handleCreateNewPoll = React.useCallback(() => {
    setTamplatePolls({
      type: "CREATE_TAMPLATE_POLL",
      payload: createTamplatePoll()
    })
  }, [setTamplatePolls])

  const data = createTamplatePoll()
  const { t } = useTranslation()
  return (
    <Box
      p="1rem 0.5rem 1rem 0"
      height="100%"
      overflowX="hidden"
      overflowY="hidden"
    >
      <Container
        roomStyles={roomStyles}
        overflowX="hidden"
        w="100%"
        overflowY="auto"
        scrollbarwidth="thin"
        p="0 0.5rem 0 1rem"
        style={{ scrollBehavior: "smooth" }}
        /* spacing={4} */
        h="100%"
      >
        {polls.length === 0 && (
          <CreatePoll
            poll={createTamplatePoll()}
            isFirst={true}
            isLast={polls.length === 0 && tamplatePolls.length === 0}
            defaultInputList={data.choices}
          />
        )}
        {polls.map((poll, index) => (
          <Box key={index}>
            <CreatePoll
              poll={poll}
              isFirst={index === 0}
              isLast={index === polls.length - 1 && tamplatePolls.length === 0}
              defaultInputList={poll.choices}
            />
          </Box>
        ))}
        {tamplatePolls.map((tamplatePoll, index) => (
          <Box key={index}>
            <CreatePoll
              poll={tamplatePoll}
              isFirst={false}
              isLast={index === tamplatePolls.length - 1}
              defaultInputList={tamplatePoll.choices}
            />
          </Box>
        ))}
        {polls.length !== 0 && tamplatePolls.length === 0 && (
          <CreateAnotherPollContainer>
            <CreateAnotherPoll
              onClick={handleCreateNewPoll}
              roomStyles={roomStyles}
            >
              {t("Create a new poll")}
            </CreateAnotherPoll>
          </CreateAnotherPollContainer>
        )}
      </Container>
    </Box>
  )
}

export const Polls = React.memo(_Polls)
